import { useEffect, useState } from 'react';
import { getShoppingCredit } from '../../services/ace';

const useShoppingCreditState = (): number => {
  const [shoppingCredit, setShoppingCredit] = useState(0);
  useEffect(() => {
    const fetchShoppingCredit = async () => {
      const { shoppingCredit: fetchedShoppingCredit } = await getShoppingCredit();
      setShoppingCredit(fetchedShoppingCredit);
    };
    fetchShoppingCredit();
  }, []);
  return shoppingCredit;
};

export default useShoppingCreditState;
